"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const ChatHeader = ({ receiver, linkTranslation, onLinkClick }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(receiver === null || receiver === void 0 ? void 0 : receiver.photo) &&
                        (typeof receiver.photo === "string" ? ((0, jsx_runtime_1.jsx)("img", { src: receiver.photo, alt: "coach photo" }, void 0)) : (receiver.photo)), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: receiver === null || receiver === void 0 ? void 0 : receiver.name }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { onClick: onLinkClick, children: linkTranslation }, void 0)] }, void 0));
};
exports.ChatHeader = ChatHeader;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-bottom: none;
  display: flex;
  justify-content: space-between;
  padding-left: 0 !important;
  padding-right: 0 !important;

  h2,
  h4 {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    display: flex;
    padding: ${({ theme }) => theme.spacings.m};

    img {
      border-radius: 50%;
      height: 1.5rem;
      margin-right: ${({ theme }) => theme.spacings.m};
      width: 1.5rem;
    }
  }

  & h4 {
    cursor: pointer;
    padding: ${({ theme }) => theme.spacings.m};
    text-decoration: underline;
  }
`;
//# sourceMappingURL=ChatHeader.js.map